const activeComponent = (state) => {
  return state.steps.find(step => step.active === true)
}

const fieldsWithValue = (state) => {
  return state.formFields
}

const listServicos = (state) => {
  return state.servicos
}

const getServico = (state) => {
  return id => state.servicos.find(e => {
    return e.id === id
  }).nome
}

const getModalidadesDeEntrega = (state) => {
  return state.modalidadesDeEntrega
}

const getRegions = (state) => {
  return state.regions
}

const getActualProtocol = (state) => {
  return state.protocolo
}

const getLabels = (state) => {
  return state.labels
}

export default {
  activeComponent,
  fieldsWithValue,
  listServicos,
  getServico,
  getModalidadesDeEntrega,
  getRegions,
  getActualProtocol,
  getLabels
}
